import { Component, OnInit, inject } from '@angular/core';
import { GameService, InternationalizationService, SessionService, User } from '@app/core/services';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { JeopardyUser, SortEnumType } from '@app/shared/graphql/types';

@Component({
    selector: 'app-leaderboard',
    templateUrl: './leaderboard.component.html',
    styleUrls: ['./leaderboard.component.scss'],
    imports: [NgClass, RouterLink]
})
export class LeaderboardComponent implements OnInit {
  public leaderboard: JeopardyUser[];
  public activeTab: string;
  public currentUser: User;
  public entries: number = 10;

  public i18n = inject(InternationalizationService);
  public gameService = inject(GameService);
  public sessionService = inject(SessionService);

  ngOnInit(): void {
    this.setActiveTab(null, 'global');
    this.currentUser = this.sessionService.getUser();
  }

  public setActiveTab(event: Event, tab: string) {
    if(event) {
      event.preventDefault();
    }

    this.activeTab = tab;

    const order = [
      { score: SortEnumType.Desc},
      { name: SortEnumType.Asc },
    ];

    const where = {
      name : { neq: '' },
      score: {
        gt: 1000
      },
      location: this.activeTab === 'country' ? { eq: this.currentUser.location.country.value } : undefined,
    };

    this.gameService.getUsers(order, this.entries, undefined, undefined, undefined, where).subscribe((players) => {
      this.leaderboard = players.nodes;
      console.log('leaderboard', this.leaderboard);
    });
  }
}
